import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import SpurLogo from '../images/SpurLogo.png';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollToSection = (sectionId) => {
    setIsMenuOpen(false);
    setActiveSection(sectionId);

    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation, then scroll
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
  };

  const scrollToSection = (sectionId) => {
    if (sectionId === 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = 80;
      const elementPosition = element.offsetTop - navHeight - 20;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleAgConvergeNavigation = () => {
    setIsMenuOpen(false);
    navigate('/agconverge');
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <button
          onClick={() => handleScrollToSection('home')}
          className="logo"
        >
          <div className="logo-icon">
            <img
              src={SpurLogo}
              alt="The Spur"
              className="logo-image"
            />
          </div>
        </button>

        <ul className={`nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
          <li>
            <button
              className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
              onClick={() => handleScrollToSection('home')}
            >
              Home
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
              onClick={() => handleScrollToSection('about')}
            >
              About
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${activeSection === 'programs' ? 'active' : ''}`}
              onClick={() => handleScrollToSection('programs')}
            >
              Programs
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${activeSection === 'events' ? 'active' : ''}`}
              onClick={() => handleScrollToSection('events')}
            >
              Events
            </button>
          </li>
          <li>
            <Link
              to="/resources"
              className={`nav-link ${location.pathname === '/resources' ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Resources
            </Link>
          </li>
          <li>
            <button
              className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
              onClick={() => handleScrollToSection('contact')}
            >
              Contact
            </button>
          </li>
        </ul>

        {/** 
        <div className="nav-cta-group">
          <button
            className="nav-cta"
            onClick={handleAgConvergeNavigation}
          >
            AgConverge '25
          </button>
        </div>
*/}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;